import { useSelector } from 'react-redux';
import { DashboardEstimate, EstimatesStatus } from '../../../../types/dashboardInformation';
import { useEffect, useState } from 'react';

export const useInDraftEstimates = () => {
    //@ts-ignore
    const { estimates, is_customer } = useSelector((state) => state.dashboardReducer);

    const [inDraftEstimates, setInDraftEstimates] = useState(
        estimates.estimates.filter(
            (estimate: DashboardEstimate) =>
                estimate.status === EstimatesStatus.DRAFT ||
                estimate.status === EstimatesStatus.ON_AGREEMENT
        )
    );

    useEffect(() => {
        setInDraftEstimates(
            estimates.estimates.filter(
                (estimate: DashboardEstimate) =>
                    estimate.status === EstimatesStatus.DRAFT ||
                    estimate.status === EstimatesStatus.ON_AGREEMENT
            )
        );
    }, [estimates.estimates]);

    return { estimates, inDraftEstimates, is_customer };
};
